import * as o from "react";
import { g as x } from "./mutation-De-1gXxl.js";
import { S as b, s as v, h as c, n as u, g as y, i as w, k as j } from "./ZudokuContext-BcqSiygJ.js";
import { j as a } from "./jsx-runtime-DywqP_6a.js";
import { c as N } from "./index-DI5SPFK9.js";
import { c as n } from "./cn-dYga0KKN.js";
import * as r from "@radix-ui/react-select";
import { ChevronDown as h, ChevronUp as S, Check as C } from "lucide-react";
var O = class extends b {
  #s;
  #a = void 0;
  #t;
  #e;
  constructor(t, e) {
    super(), this.#s = t, this.setOptions(e), this.bindMethods(), this.#r();
  }
  bindMethods() {
    this.mutate = this.mutate.bind(this), this.reset = this.reset.bind(this);
  }
  setOptions(t) {
    const e = this.options;
    this.options = this.#s.defaultMutationOptions(t), v(this.options, e) || this.#s.getMutationCache().notify({
      type: "observerOptionsUpdated",
      mutation: this.#t,
      observer: this
    }), e?.mutationKey && this.options.mutationKey && c(e.mutationKey) !== c(this.options.mutationKey) ? this.reset() : this.#t?.state.status === "pending" && this.#t.setOptions(this.options);
  }
  onUnsubscribe() {
    this.hasListeners() || this.#t?.removeObserver(this);
  }
  onMutationUpdate(t) {
    this.#r(), this.#i(t);
  }
  getCurrentResult() {
    return this.#a;
  }
  reset() {
    this.#t?.removeObserver(this), this.#t = void 0, this.#r(), this.#i();
  }
  mutate(t, e) {
    return this.#e = e, this.#t?.removeObserver(this), this.#t = this.#s.getMutationCache().build(this.#s, this.options), this.#t.addObserver(this), this.#t.execute(t);
  }
  #r() {
    const t = this.#t?.state ?? x();
    this.#a = {
      ...t,
      isPending: t.status === "pending",
      isSuccess: t.status === "success",
      isError: t.status === "error",
      isIdle: t.status === "idle",
      mutate: this.mutate,
      reset: this.reset
    };
  }
  #i(t) {
    u.batch(() => {
      if (this.#e && this.hasListeners()) {
        const e = this.#a.variables, s = this.#a.context;
        t?.type === "success" ? (this.#e.onSuccess?.(t.data, e, s), this.#e.onSettled?.(t.data, null, e, s)) : t?.type === "error" && (this.#e.onError?.(t.error, e, s), this.#e.onSettled?.(
          void 0,
          t.error,
          e,
          s
        ));
      }
      this.listeners.forEach((e) => {
        e(this.#a);
      });
    });
  }
};
function V(t, e) {
  const s = y(e), [i] = o.useState(
    () => new O(
      s,
      t
    )
  );
  o.useEffect(() => {
    i.setOptions(t);
  }, [i, t]);
  const l = o.useSyncExternalStore(
    o.useCallback(
      (d) => i.subscribe(u.batchCalls(d)),
      [i]
    ),
    () => i.getCurrentResult(),
    () => i.getCurrentResult()
  ), f = o.useCallback(
    (d, g) => {
      i.mutate(d, g).catch(w);
    },
    [i]
  );
  if (l.error && j(i.options.throwOnError, [l.error]))
    throw l.error;
  return { ...l, mutate: f, mutateAsync: l.mutate };
}
const R = N(
  "relative w-full rounded-lg border px-4 py-3 text-sm grid has-[>svg]:grid-cols-[calc(var(--spacing)*4)_1fr] grid-cols-[0_1fr] has-[>svg]:gap-x-3 gap-y-0.5 items-start [&>svg]:size-4 [&>svg]:translate-y-0.5 [&>svg]:text-current",
  {
    variants: {
      variant: {
        default: "bg-card text-card-foreground",
        destructive: "text-destructive bg-card [&>svg]:text-current *:data-[slot=alert-description]:text-destructive/90"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function z({
  className: t,
  variant: e,
  ...s
}) {
  return /* @__PURE__ */ a.jsx(
    "div",
    {
      "data-slot": "alert",
      role: "alert",
      className: n(R({ variant: e }), t),
      ...s
    }
  );
}
function P({ className: t, ...e }) {
  return /* @__PURE__ */ a.jsx(
    "div",
    {
      "data-slot": "alert-title",
      className: n(
        "col-start-2 line-clamp-1 min-h-4 font-medium tracking-tight",
        t
      ),
      ...e
    }
  );
}
function _({
  className: t,
  ...e
}) {
  return /* @__PURE__ */ a.jsx(
    "div",
    {
      "data-slot": "alert-description",
      className: n(
        "text-muted-foreground col-start-2 grid justify-items-start gap-1 text-sm [&_p]:leading-relaxed",
        t
      ),
      ...e
    }
  );
}
const G = r.Root, q = r.Group, Q = r.Value, M = o.forwardRef(({ className: t, children: e, ...s }, i) => /* @__PURE__ */ a.jsxs(
  r.Trigger,
  {
    ref: i,
    className: n(
      "flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-hidden focus:ring-1 focus:ring-ring focus:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50",
      t
    ),
    ...s,
    children: [
      /* @__PURE__ */ a.jsx("span", { className: "truncate", children: e }),
      /* @__PURE__ */ a.jsx(r.Icon, { asChild: !0, children: /* @__PURE__ */ a.jsx(h, { className: "shrink-0 h-4 w-4 opacity-50" }) })
    ]
  }
));
M.displayName = r.Trigger.displayName;
const m = o.forwardRef(({ className: t, ...e }, s) => /* @__PURE__ */ a.jsx(
  r.ScrollUpButton,
  {
    ref: s,
    className: n(
      "flex cursor-default items-center justify-center py-1",
      t
    ),
    ...e,
    children: /* @__PURE__ */ a.jsx(S, { className: "h-4 w-4" })
  }
));
m.displayName = r.ScrollUpButton.displayName;
const p = o.forwardRef(({ className: t, ...e }, s) => /* @__PURE__ */ a.jsx(
  r.ScrollDownButton,
  {
    ref: s,
    className: n(
      "flex cursor-default items-center justify-center py-1",
      t
    ),
    ...e,
    children: /* @__PURE__ */ a.jsx(h, { className: "h-4 w-4" })
  }
));
p.displayName = r.ScrollDownButton.displayName;
const E = o.forwardRef(({ className: t, children: e, position: s = "popper", ...i }, l) => /* @__PURE__ */ a.jsx(r.Portal, { children: /* @__PURE__ */ a.jsxs(
  r.Content,
  {
    ref: l,
    className: n(
      "relative z-50 max-h-96 min-w-[8rem] overflow-hidden rounded-md border bg-popover text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      s === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
      t
    ),
    position: s,
    ...i,
    children: [
      /* @__PURE__ */ a.jsx(m, {}),
      /* @__PURE__ */ a.jsx(
        r.Viewport,
        {
          className: n(
            s === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]",
            "divide-y"
          ),
          children: e
        }
      ),
      /* @__PURE__ */ a.jsx(p, {})
    ]
  }
) }));
E.displayName = r.Content.displayName;
const k = o.forwardRef(({ className: t, ...e }, s) => /* @__PURE__ */ a.jsx(
  r.Label,
  {
    ref: s,
    className: n("py-1.5 pl-8 pr-2 text-sm font-semibold", t),
    ...e
  }
));
k.displayName = r.Label.displayName;
const I = o.forwardRef(({ className: t, children: e, ...s }, i) => /* @__PURE__ */ a.jsxs(
  r.Item,
  {
    ref: i,
    className: n(
      "relative flex w-full cursor-default select-none items-center py-1.5 pl-8 pr-2 text-sm outline-hidden focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      t
    ),
    ...s,
    children: [
      /* @__PURE__ */ a.jsx("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ a.jsx(r.ItemIndicator, { children: /* @__PURE__ */ a.jsx(C, { className: "h-4 w-4" }) }) }),
      /* @__PURE__ */ a.jsx(r.ItemText, { children: e })
    ]
  }
));
I.displayName = r.Item.displayName;
const U = o.forwardRef(({ className: t, ...e }, s) => /* @__PURE__ */ a.jsx(
  r.Separator,
  {
    ref: s,
    className: n("-mx-1 my-1 h-px bg-muted", t),
    ...e
  }
));
U.displayName = r.Separator.displayName;
export {
  z as A,
  G as S,
  P as a,
  _ as b,
  M as c,
  Q as d,
  E as e,
  q as f,
  I as g,
  V as u
};
//# sourceMappingURL=Select-BiBMWiLv.js.map
